import { Injectable, inject } from '@angular/core';

import { SharedFeaturesApiService, TrackingService, UserService } from '@frontend/vanilla/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { AffordabilitySnapshotDetails } from './affordability.models';

@Injectable({
    providedIn: 'root',
})
export class AffordabilityService {
    private apiService = inject(SharedFeaturesApiService);
    private user = inject(UserService);
    private trackingService = inject(TrackingService);

    readonly snapshotDetails = new BehaviorSubject<AffordabilitySnapshotDetails | null>(null);

    private loaded = false;

    /**
     * @description Will not call the API if user is not authenticated.
     */
    load(): void {
        if (this.user.isAuthenticated && !this.loaded) {
            this.loaded = true;

            this.apiService.post('affordability/snapshotdetails').subscribe((snapshotDetails: AffordabilitySnapshotDetails) => {
                if (snapshotDetails?.affordabilityStatus) {
                    this.trackingService.updateDataLayer({
                        'user.affordabilityJourney': snapshotDetails.affordabilityStatus?.toLowerCase(),
                    });
                }
                this.snapshotDetails.next(snapshotDetails);
            });
        }
    }

    /**
     * @description Ensures snapshot details are loaded before returning.
     */
    getSnapshotDetails(): Observable<AffordabilitySnapshotDetails> {
        // Trigger load if not already done
        if (!this.loaded) {
            this.load();
        }

        // Return observable that only emits when snapshotDetails is available
        return this.snapshotDetails.asObservable().pipe(
            filter((details): details is AffordabilitySnapshotDetails => !!details),
            take(1),
        );
    }
}
